/**
 * Sticky marker connecting a canvas insert gesture (menu click, shortcut,
 * drop, paste, …) to the `CanvasContext.addNode` seam that emits
 * `Canvas Node Added`. Marked at the gesture, consumed at the add; the TTL
 * keeps an abandoned gesture from mislabeling a later unrelated insert.
 */

import type { CanvasNodeSource } from "@/analytics/surfaces";

const TTL_MS = 10_000;

let marked: { source: CanvasNodeSource; at: number } | null = null;

export function markInsertSource(source: CanvasNodeSource): void {
  marked = { source, at: Date.now() };
}

export function consumeInsertSource(): CanvasNodeSource | null {
  if (!marked) return null;
  const { source, at } = marked;
  marked = null;
  return Date.now() - at <= TTL_MS ? source : null;
}

export function clearInsertSource(): void {
  marked = null;
}
